function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.85 4.923c1.656.881 2.962 2.076 3.917 3.581L31.1 10.406c-1.645-2.45-3.889-3.677-6.734-3.677-2.267 0-4.156.748-5.666 2.242-1.511 1.495-2.267 3.371-2.267 5.63 0 2.258.756 4.134 2.267 5.629 1.51 1.494 3.399 2.242 5.666 2.242 2.845 0 5.089-1.226 6.735-3.677l2.666 1.902c-.934 1.505-2.228 2.7-3.883 3.58-1.657.884-3.506 1.324-5.55 1.324-3.246 0-5.984-1.054-8.219-3.16-2.232-2.109-3.35-4.722-3.35-7.84 0-3.097 1.123-5.705 3.368-7.824 2.245-2.119 4.977-3.176 8.2-3.176 2.022 0 3.86.441 5.518 1.322zM44.49 21.345c.81-.704 1.216-1.59 1.216-2.657V18.4h-4.142c-1.905 0-2.858.64-2.858 1.92 0 .662.263 1.174.788 1.538.526.363 1.205.542 2.038.542 1.161 0 2.147-.352 2.957-1.055zm2.704-11.21C48.399 11.293 49 12.954 49 15.114v9.726h-3.22v-1.8c-1.206 1.44-2.926 2.16-5.16 2.16-1.689 0-3.046-.425-4.077-1.277C35.515 23.073 35 21.948 35 20.55c0-1.397.537-2.51 1.61-3.34 1.074-.83 2.52-1.244 4.339-1.244h4.57v-1.048c0-1.114-.304-1.965-.905-2.555-.603-.588-1.451-.884-2.547-.884-1.621 0-3.112.796-4.47 2.392l-2.006-2.03c1.622-2.295 3.89-3.44 6.804-3.44 1.994 0 3.593.578 4.799 1.735zM60.536 8.961v3.002h-1.032c-1.333 0-2.44.38-3.321 1.144-.881.763-1.322 1.845-1.322 3.243v8.45h-3.384V8.962h3.158v2.066c1.118-1.484 2.655-2.226 4.61-2.226.474 0 .904.053 1.29.16zM73.93 20.543c.951-.973 1.427-2.226 1.427-3.76 0-1.512-.476-2.753-1.427-3.725-.95-.972-2.133-1.458-3.548-1.458-1.348 0-2.504.449-3.465 1.345-.962.896-1.443 2.186-1.443 3.87 0 1.708.481 3 1.443 3.874.961.873 2.117 1.311 3.465 1.311 1.415 0 2.598-.486 3.548-1.457zm2.867-9.835c1.511 1.573 2.266 3.533 2.266 5.884 0 2.352-.75 4.308-2.25 5.868-1.502 1.56-3.4 2.34-5.694 2.34-1.193 0-2.29-.223-3.295-.672-1.003-.45-1.804-1.08-2.4-1.893v2.213H62.18V.4h3.476v10.228c1.28-1.517 3.09-2.276 5.43-2.276 2.295 0 4.199.787 5.71 2.356zM85.885 13.111c-.978.987-1.468 2.227-1.468 3.72 0 1.476.484 2.705 1.453 3.69.966.986 2.193 1.48 3.677 1.48 1.463 0 2.69-.494 3.681-1.48.988-.985 1.484-2.214 1.484-3.69 0-1.493-.489-2.733-1.468-3.72-.979-.985-2.2-1.489-3.662-1.51-1.486.021-2.718.525-3.697 1.51zm9.577-2.286c1.696 1.615 2.544 3.601 2.544 5.959 0 2.358-.848 4.351-2.544 5.977-1.697 1.628-3.742 2.44-6.137 2.44-2.416-.022-4.456-.841-6.119-2.456-1.663-1.617-2.495-3.603-2.495-5.961s.832-4.344 2.495-5.959C84.87 9.21 86.91 8.4 89.325 8.4c2.395 0 4.44.809 6.137 2.425zM114.475 14.77V24.8h-3.527v-9.572c0-1.11-.331-2.008-.992-2.694-.66-.688-1.527-1.03-2.603-1.03-1.097 0-1.998.349-2.704 1.046-.706.696-1.059 1.59-1.059 2.678V24.8h-3.528V8.76h3.294v1.6c1.23-1.306 2.878-1.96 4.938-1.96 1.926 0 3.438.584 4.535 1.748 1.098 1.165 1.646 2.706 1.646 4.623zM121.545 12.284c-.87.723-1.442 1.695-1.714 2.916h9.059c-.022-1.22-.44-2.193-1.255-2.916-.816-.724-1.821-1.084-3.02-1.084-1.175 0-2.199.36-3.07 1.084zm10.373 5.647h-12.221c.223 1.331.812 2.368 1.769 3.11.958.744 2.149 1.114 3.573 1.114 1.714 0 3.305-.632 4.775-1.899l1.67 2.358c-1.871 1.724-4.052 2.586-6.545 2.586-2.538 0-4.641-.801-6.309-2.406-1.671-1.605-2.505-3.597-2.505-5.978 0-2.357.817-4.349 2.453-5.976 1.637-1.627 3.646-2.44 6.027-2.44 2.181 0 3.99.7 5.426 2.096 1.435 1.398 2.154 3.154 2.154 5.273 0 .676-.089 1.398-.267 2.162z",
  fill: "#50525D"
});

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "CX-logo_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 132,
  y: 8,
  width: 17,
  height: 17
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M148.247 24.8v-16h-16.059v16h16.059z",
  fill: "#fff"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#CX-logo_svg__a)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M144.273 24.8l-4.04-5.8-4.072 5.8h-3.973l6.058-8.309-5.628-7.69h3.974l3.641 5.214 3.61-5.214h3.973l-5.663 7.69 6.094 8.31h-3.974z",
  fill: "#50525D"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("mask", {
  id: "CX-logo_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 2,
  width: 12,
  height: 11
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.414 2.4v10.4h10.707V2.4H.413z",
  fill: "#fff"
})), React.createElement("g", {
  mask: "url(#CX-logo_svg__b)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.106 12.8L.414 4.357 2.428 2.4l8.692 8.443L9.107 12.8z",
  fill: "#1DE9B6"
})), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.428 12.8L.414 10.843 9.106 2.4l2.014 1.957L2.428 12.8z",
  fill: "#1DE9B6"
}));

var SvgCxLogo = function SvgCxLogo(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 150 26",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgCxLogo;